import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiContainer, SuiButton, SuiLabel } from '@splashthat/sui';
import AddOutlineIcon from 'common/icons/AddOutline';
import {
    LOGIC_PROPERTY_VISIBLE,
    LOGIC_OPERATOR_EQUALS,
    VALUE_TYPE_QUESTION,
    VALUE_TYPE_STRING,
} from 'common/entities/formLogicRule/constants';

import FormLogicConditionSet from './FormLogicConditionSet';

import './FormLogicEditor.styl';

export const QUESTION_LOGIC = 'Question Logic';
export const PROTECTED_QUESTION_LOGIC = 'Protected Field Question Logic';
const ADD_CONDITION = 'Add Condition';
const BASE_CLASS_NAME = 'FormLogicEditor';

export default class FormLogicEditor extends Component {
    static propTypes = {
        formNode: PropTypes.object.isRequired,
        formNodeVisibilityLogicRules: PropTypes.array,
        operandNodes: PropTypes.array,
        addNodeLogicEffect: PropTypes.func.isRequired,
        removeFormLogicEffect: PropTypes.func.isRequired,
        updateFormLogicEffect: PropTypes.func.isRequired,
    };

    static defaultProps = {
        formNodeVisibilityLogicRules: [],
        operandNodes: [],
    };

    handleClickAddCondition = (event) => {
        // @TODO: This is a hardcoded thing should be configuration-based
        const logic = {
            defaultValue: false,
            defaultValueType: null,
            operandLeftType: VALUE_TYPE_QUESTION,
            operandLeft: '',
            operator: LOGIC_OPERATOR_EQUALS,
            operandRightType: VALUE_TYPE_STRING,
            operandRight: '',
        };

        this.props.addNodeLogicEffect({
            targetId: this.props.formNode.id,
            property: LOGIC_PROPERTY_VISIBLE,
            logicRule: logic,
        });
    };

    getSentenceText(formNodeVisibilityLogicRules) {
        return formNodeVisibilityLogicRules.length ? 'will be hidden unless' : 'is always visible';
    }

    render() {
        const { formNode, formNodeVisibilityLogicRules, operandNodes } = this.props;
        return (
            <SuiContainer variation="flex-vertical flex-inherit">
                <SuiContainer variation="flex-group">
                    <SuiLabel>{formNode?.protected ? PROTECTED_QUESTION_LOGIC : QUESTION_LOGIC}</SuiLabel>
                </SuiContainer>

                <SuiContainer variation="flex-group flex-horizontal-left">
                    <SuiContainer variation="flex-horizontal flex-inherit">
                        <SuiContainer variation="flex-group" className={`${BASE_CLASS_NAME}__question-label`}>
                            {formNode.label}
                        </SuiContainer>
                        <SuiContainer variation="flex-group" className={`${BASE_CLASS_NAME}__sentence`}>
                            {this.getSentenceText(formNodeVisibilityLogicRules)}
                        </SuiContainer>
                    </SuiContainer>
                </SuiContainer>
                <SuiContainer variation="flex-group">
                    <FormLogicConditionSet
                        logicRules={formNodeVisibilityLogicRules}
                        operandNodes={operandNodes}
                        removeFormLogicEffect={this.props.removeFormLogicEffect}
                        updateFormLogicEffect={this.props.updateFormLogicEffect}
                        formNodeWithLogicIsProtected={formNode.protected}
                    />
                </SuiContainer>

                <SuiContainer variation="flex-group">
                    <SuiButton
                        variation="text"
                        label={ADD_CONDITION}
                        iconBefore={AddOutlineIcon}
                        onClick={this.handleClickAddCondition}
                    />
                </SuiContainer>
            </SuiContainer>
        );
    }
}
